export const MODEL_SETTINGS_STORAGE_KEY = 'jamcam-model-diagnostics-settings';

export interface JamCamModelDiagnosticsSettings {
  runtime: {
    provider: 'tfjs' | 'onnx-web' | 'wasm' | 'hybrid';
    maxConcurrentModels: number;
    warmupOnStart: boolean;
  };
  models: {
    keypoint: { enabled: boolean; variant: string };
    segmentation: { enabled: boolean; variant: string };
    bbox: { enabled: boolean; variant: string };
    handDetection: { enabled: boolean; variant: string };
    handPose: { enabled: boolean; variant: string };
  };
  diagnostics: {
    overlayEnabled: boolean;
    showDebugPanel: boolean;
    logTimings: boolean;
    processIntervalMs: number;
    smoothingFactor: number;
    confidence: {
      keypoint: number;
      segmentation: number;
      bbox: number;
      handDetection: number;
      handPose: number;
    };
  };
  capture: {
    autoSnapshotOnDetection: boolean;
    includeRawFrame: boolean;
    includeOverlayFrame: boolean;
    snapshotCooldownMs: number;
    maxSnapshotsPerSession: number;
  };
}

export const defaultModelDiagnosticsSettings: JamCamModelDiagnosticsSettings = {
  runtime: {
    provider: 'hybrid',
    maxConcurrentModels: 3,
    warmupOnStart: true,
  },
  models: {
    keypoint: { enabled: true, variant: 'kpt-v4' },
    segmentation: { enabled: true, variant: 'seg-neck-v2' },
    bbox: { enabled: true, variant: 'bbox-v3' },
    handDetection: { enabled: false, variant: 'hand-det-v1' },
    handPose: { enabled: false, variant: 'hand-pose-v1' },
  },
  diagnostics: {
    overlayEnabled: true,
    showDebugPanel: true,
    logTimings: false,
    processIntervalMs: 350,
    smoothingFactor: 0.35,
    confidence: {
      keypoint: 0.45,
      segmentation: 0.4,
      bbox: 0.4,
      handDetection: 0.5,
      handPose: 0.5,
    },
  },
  capture: {
    autoSnapshotOnDetection: false,
    includeRawFrame: true,
    includeOverlayFrame: true,
    snapshotCooldownMs: 1200,
    maxSnapshotsPerSession: 200,
  },
};
